var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import { mapGetters } from "vuex";
import _ from 'lodash';
import { UrlHelper } from "../../helper/UrlWrapper";
import GlobalVue from "../../globalVue";
import { EPlanOrderForUpperSupStatus as EOrderStatus } from "../../enum/EStatus";
import { EBillType } from "../../enum/EBillType";
import { toDetail } from '../../helper/util';
import PlanOrderForUpperSupService from '../../api/PlanOrderForUpperSupService';
import Add from './Add.vue';
import Header from "./components/Header.vue";
import BillSubTable from "./components/BillSubTable.vue";
import ImportData from "../../components/dataActions/ImportData.vue";
import CommonService from "../../api/CommonService";
var PlanOrderForUpperSupList = (function (_super) {
    __extends(PlanOrderForUpperSupList, _super);
    function PlanOrderForUpperSupList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eOrderStatus = EOrderStatus;
        _this.listData = [];
        _this.total = 0;
        _this.selectRows = [];
        _this.tableHeight = 300;
        return _this;
    }
    PlanOrderForUpperSupList.prototype.created = function () {
        this.service = PlanOrderForUpperSupService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    PlanOrderForUpperSupList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
    };
    PlanOrderForUpperSupList.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        if (!filter.s_time) {
            this.$message.error('请选择开始日期');
            return;
        }
        if (!filter.e_time) {
            this.$message.error('请选择结束日期');
            return;
        }
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
        }
        if (_.isDate(filter.e_time)) {
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        filter.order_status = filter.order_status.join(',');
        this.filter = filter;
        this.getList();
    };
    PlanOrderForUpperSupList.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getList(Object.assign({}, this.filter, this.filter, pager)).then(function (res) {
            loadingInstance.close();
            var data = res.data.data.map(function (v) {
                v.listGoods = [];
                return v;
            });
            _this.listData = data;
            _this.total = res.data.total;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    PlanOrderForUpperSupList.prototype.expandChange = function (row, expandedRows) {
        var _this = this;
        if (expandedRows.length == 0) {
            return;
        }
        var params = {
            plan_order_id: row.order_id
        };
        var index = this.listData.indexOf(row);
        this.service.getListOrders(params).then(function (res) {
            var listGoods = res.data.data || [];
            GlobalVue.$set(_this.listData[index], 'listGoods', listGoods);
            window._czc.push(["_trackEvent", '采购计划', '采购计划展开分单结果']);
            _this.$nextTick(function () {
                window.vue1 = _this.$refs['table'];
                _this.$refs['table'].doLayout();
            });
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PlanOrderForUpperSupList.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    PlanOrderForUpperSupList.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    PlanOrderForUpperSupList.prototype.add = function () {
        this.addTab({
            component: Add,
            title: '添加采购计划',
            showExist: true,
            name: 'plan_order_for_upper_supadd',
            cprops: {}
        });
        window._czc.push(["_trackEvent", '采购计划', '采购计划添加']);
    };
    PlanOrderForUpperSupList.prototype.edit = function (row) {
        this.addTab({
            component: Add,
            title: '修改采购计划',
            showExist: true,
            name: 'plan_order_for_upper_supedit' + row.order_id,
            cprops: {
                orderid: row.order_id
            }
        });
        window._czc.push(["_trackEvent", '采购计划', '采购计划编辑']);
    };
    PlanOrderForUpperSupList.prototype.check = function (row) {
        toDetail(EBillType.PlanOrderForUpperSup, row.order_id, this);
        window._czc.push(["_trackEvent", '采购计划', '采购计划查看']);
    };
    PlanOrderForUpperSupList.prototype.audit = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        this.$confirm("审核后订单会根据供应商进行自动分单且不可更改，确定审核吗？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.audit({
                order_ids: _this.selectRows.map(function (item) { return item.order_id; }).join(",")
            }).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success("审核成功");
                    window._czc.push(["_trackEvent", '采购计划', '采购计划审核']);
                }
                _this.getList();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PlanOrderForUpperSupList.prototype.discard = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        this.$confirm("确认后会废弃计划单且不可恢复，确定废弃吗？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.discard({
                order_ids: _this.selectRows.map(function (item) { return item.order_id; }).join(",")
            }).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success("废弃成功");
                    window._czc.push(["_trackEvent", '采购计划', '采购计划废弃']);
                }
                _this.getList();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PlanOrderForUpperSupList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    PlanOrderForUpperSupList.prototype.lookSubDetail = function (row) {
        toDetail(EBillType.PurchaseOrderForUpperSup, row.order_id, this);
        window._czc.push(["_trackEvent", '采购计划', '采购订货查看']);
    };
    PlanOrderForUpperSupList.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.importAudit();
                break;
            case 2:
                this.exportData();
                break;
            case 3:
                this.discard();
                break;
            case 4:
                this.print();
                break;
        }
    };
    PlanOrderForUpperSupList.prototype.importAudit = function () {
        this.$refs.ImportData.showImportModal();
    };
    PlanOrderForUpperSupList.prototype.exportData = function () {
        var _this = this;
        var orderIds = [];
        this.selectRows.forEach(function (item) {
            orderIds.push(item.order_id);
        });
        var url = "supplierclientapi/planorder/export?order_ids=" + orderIds.join(",");
        url = UrlHelper.addParam(url, 'token', this.user.token);
        var filter = _.cloneDeep(this.$refs.listHeader.formData);
        if (!filter.s_time) {
            this.$message.error('请选择开始日期');
            return;
        }
        if (!filter.e_time) {
            this.$message.error('请选择结束日期');
            return;
        }
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
        }
        if (_.isDate(filter.e_time)) {
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        filter.order_status = filter.order_status.join(',');
        this.filter = filter;
        for (var key in this.filter) {
            this.filter[key] = (this.filter[key] === undefined || this.filter[key] === null) ? '' : this.filter[key];
            url = UrlHelper.addParam(url, key, this.filter[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        window._czc.push(["_trackEvent", '采购计划', '采购计划导出']);
    };
    PlanOrderForUpperSupList.prototype.print = function () {
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        var orderIds = [];
        this.selectRows.forEach(function (item) {
            orderIds.push(item.order_id);
        });
        var url = "./static/js/print/print2.html";
        url = UrlHelper.addParam(url, 'type', "planOrderForUpperSup");
        url = UrlHelper.addParam(url, 'order_id', orderIds.join(","));
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
        window._czc.push(["_trackEvent", '采购计划', '采购计划打印']);
    };
    PlanOrderForUpperSupList = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            components: {
                'list-header': Header,
                'bill-sub-table': BillSubTable,
                'import-data': ImportData,
            },
            methods: {
                getRowClass: function (_a) {
                    var row = _a.row, index = _a.index;
                    if ([EOrderStatus.Audited, EOrderStatus.Complete].indexOf(row.order_status) > -1) {
                        return '';
                    }
                    else {
                        return 'hide-expand-btn';
                    }
                    ;
                }
            }
        })
    ], PlanOrderForUpperSupList);
    return PlanOrderForUpperSupList;
}(Vue));
export default PlanOrderForUpperSupList;
